import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { BrTabItems } from 'views/BrTabs/BrTabs';
import { ProfilingSection } from 'views/BrTabs/components/ProfilingSections/ProfilingSection';
import { useRuntimeConfig } from 'config/useRuntimeConfig';
import { NavigationWizardSectionRenderParams } from 'views/BrTabs/types/navigationWizardMode';
import { ZfBrRelationsNavigationWrapperWC } from '@juliusbaer-gcrm/pcm-br-mgmt-components/ZfBrRelationsNavigationWrapperWC';

export function BrRelationsSection({ selectedTab, navigateToTab }: NavigationWizardSectionRenderParams): ReactNode {
  const runtimeConfig = useRuntimeConfig();
  const { t } = useTranslation();
  const isActive = selectedTab === BrTabItems.BR_RELATIONS;

  return ProfilingSection({
    tabId: BrTabItems.BR_RELATIONS,
    title: t('navigationWizard.item.title.brRelations'),
    isActive,
    isProfilingRelevant: false,
    onSectionSelect: () => navigateToTab(BrTabItems.BR_RELATIONS),
    children: (
      <ZfBrRelationsNavigationWrapperWC
        env={runtimeConfig.envInfo.envId}
        version="0.0.1"
        onSectionSelect={() => navigateToTab(BrTabItems.BR_RELATIONS)}
        isActive={isActive}
      />
    ),
  });
}
